import React from 'react';
import { t } from 'i18next';
import { Trans } from 'react-i18next';
import { Heading, HeadingType, Link } from '@sovryn/ui';
import { HELPDESK_LINK } from '../../../../constants/links';
import { translations } from '../../../../locales/i18n';
export const Instructions = () => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Heading, { type: HeadingType.h2, className: "font-medium leading-[1.375rem]" },
            t(translations.erc20Bridge.instructions.title),
            ":"),
        React.createElement("ul", { className: "list-disc list-inside text-xs leading-5 font-medium text-gray-30 mt-6 mb-12" },
            React.createElement("li", { className: "mb-2" }, t(translations.erc20Bridge.instructions['1'])),
            React.createElement("li", { className: "mb-2" }, t(translations.erc20Bridge.instructions['2'])),
            React.createElement("li", { className: "mb-2" }, t(translations.erc20Bridge.instructions['3'])),
            React.createElement("li", { className: "mb-2" }, t(translations.erc20Bridge.instructions['4'])),
            React.createElement("li", { className: "mb-2" },
                React.createElement(Trans, { i18nKey: t(translations.erc20Bridge.instructions['5']), tOptions: { hours: 1.5 }, components: [
                        React.createElement(Link, { text: t(translations.erc20Bridge.instructions.createSupportTicketCta), className: "md:ml-4", href: HELPDESK_LINK }),
                    ] })))));
};
